import React from 'react';
import { activityTypes } from '../../../../../helper/constants.helper';
import { Button } from '@mui/material';

const MeetingButtons = ({ historyItem }) => {
  return (
    <>
      {historyItem.type === activityTypes.MEETING && historyItem.meetingLink && (
        <Button
          target="_blank"
          href={historyItem.meetingLink}
          variant="contained"
          color="primary"
          size="small"
          fullWidth>
          Join meeting
        </Button>
      )}
    </>
  );
};

export default MeetingButtons;
